import React, { useState, useEffect } from 'react';
import { useLabs } from '../hooks/useLabs';
import { LabsHub } from '../components/Labs/LabsHub';
import { RouteView } from '../components/Labs/RouteView';
import { LevelView } from '../components/Labs/LevelView';
import { UserStats } from '../components/Labs/UserStats';
import '../components/Labs/Labs.css';

export const LabsView = () => {
  const { selectedRoute, selectedLevel, setSelectedRoute, setSelectedLevel } = useLabs();
  const [activeTab, setActiveTab] = useState('hub'); // hub, route, level, stats

  // Sync active tab with context selections so Hub buttons work
  useEffect(() => {
    if (selectedRoute && activeTab === 'hub') {
      setActiveTab('route');
    }
  }, [selectedRoute]);

  useEffect(() => {
    if (selectedLevel && activeTab !== 'level') {
      setActiveTab('level');
    }
  }, [selectedLevel]);

  const handleSelectRoute = (routeId) => {
    setSelectedRoute(routeId);
    setActiveTab('route');
  };

  const handleSelectLevel = (levelId) => {
    setSelectedLevel(levelId);
    setActiveTab('level');
  };

  const handleBack = () => {
    if (activeTab === 'level') {
      setSelectedLevel(null);
      setActiveTab('route');
    } else if (activeTab === 'route') {
      setSelectedRoute(null);
      setActiveTab('hub');
    }
  };

  return (
    <div className="labs-container">
      {/* Navegación de Labs */}
      <div className="labs-navigation">
        <button 
          className={`nav-btn ${activeTab === 'hub' ? 'active' : ''}`}
          onClick={() => {
            setActiveTab('hub');
            setSelectedRoute(null);
            setSelectedLevel(null);
          }}
        >
          Hub
        </button>
        <button 
          className={`nav-btn ${activeTab === 'stats' ? 'active' : ''}`}
          onClick={() => setActiveTab('stats')}
        >
          Mis Estadísticas
        </button>
        {selectedLevel && (
          <button className="nav-btn back-btn" onClick={handleBack}>
            ← Atrás
          </button>
        )}
      </div>

      {/* Contenido */}
      <div className="labs-content">
        {activeTab === 'hub' && !selectedRoute && <LabsHub />}
        {activeTab === 'route' && selectedRoute && (
          <RouteView routeId={selectedRoute} />
        )}
        {activeTab === 'level' && selectedLevel && selectedRoute && (
          <LevelView routeId={selectedRoute} levelId={selectedLevel} />
        )}
        {activeTab === 'stats' && <UserStats />}
      </div>
    </div>
  );
};

export default LabsView;
